var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c("w-col", { attrs: { sm: "12" } }, [
        _c(
          "div",
          { staticClass: "infobox" },
          [
            _c("span", {
              directives: [
                {
                  name: "safe-html",
                  rawName: "v-safe-html",
                  value: _vm.$ct("activation-email-msg", {
                    firstname: _vm.firstname,
                    email: _vm.email,
                  }),
                  expression:
                    "$ct('activation-email-msg',{firstname:firstname,email:email})",
                },
              ],
            }),
            _c("w-link", { attrs: { to: "/account/settings" } }, [
              _vm._v(_vm._s(_vm.$ct("reset-activation-email"))),
            ]),
            _vm._v(". "),
            _c("span", {
              directives: [
                {
                  name: "safe-html",
                  rawName: "v-safe-html",
                  value: _vm.$ct("activation-email-msg-2", {
                    firstname: _vm.firstname,
                    email: _vm.email,
                  }),
                  expression:
                    "$ct('activation-email-msg-2',{firstname:firstname,email:email})",
                },
              ],
            }),
            _c(
              "w-link",
              {
                on: {
                  click: function ($event) {
                    return _vm.verifyEmailClicked()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$ct("resend-activation-email")))]
            ),
            _vm._v(". "),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }